import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { lazy, useState } from 'react';
import ProjectDetails from './ProjectDetails';
import { ProjectData } from '../types/project';
import talabatWebsite from '../assets/images/projects/talabat-website/1.website.webp';
import vodafoneWebsite from '../assets/images/projects/vodafone/vodafoneWebsite.webp';
import '../assets/styles/Project.scss';
import { faAndroid, faApple } from '@fortawesome/free-brands-svg-icons';

// Lazy-load project detail components — they contain heavy deps (react-player, image carousels)
// and only render inside a fullscreen dialog on user interaction
const TalabatWebsite = lazy(() => import('./projects/TalabatWebsite'));
const TalabatMobile = lazy(() => import('./projects/TalabatMobile'));
const HomeCMS = lazy(() => import('./projects/HomeCMS'));
const Vodafone = lazy(() => import('./projects/Vodafone'));

function Project() {
    const [selectedProject, setSelectedProject] = useState<ProjectData | null>(null);
    const mode = document.querySelector('.light-mode') ? 'light' : 'dark';

    const projects: ProjectData[] = [
        {
            id: 1,
            title: "Talabat website",
            description: "Talabat is a leading online food ordering and delivery platform in the Middle East.",
            image: talabatWebsite,
            link: "https://www.talabat.com/",
            component: TalabatWebsite
        },
        {
            id: 2,
            title: "Talabat Mobile",
            description: "Flutter-powered mobile platform — splash screens, authentication, component isolation, and observability for 30M+ users.",
            image: talabatWebsite,
            link: "https://www.talabat.com/",
            hasAndroid: true,
            hasIOS: true,
            component: TalabatMobile
        },
        {
            id: 3,
            title: "Talabat Home CMS",
            description: "Microfrontend React 18 plugin — Server-Driven UI platform enabling marketing to manage home screen components across 8 markets without app releases.",
            image: talabatWebsite,
            link: "https://www.talabat.com/",
            component: HomeCMS
        },
        {
            id: 4,
            title: "Vodafone Germany",
            description: "Vodafone telecommunications website.",
            image: vodafoneWebsite,
            link: "https://vodafone.de",
            component: Vodafone
        }
    ];

    return (
        <div className="projects-container" id="projects">
            <h1>Projects</h1>
            <div className="projects-grid">
                {projects.map((project) => (
                    <div
                        key={project.id}
                        className="project"
                        onClick={() => setSelectedProject(project)}
                        style={{ cursor: 'pointer' }}
                    >
                        <img src={project.image} className="zoom" alt={project.title} width="100%" loading="lazy" />
                        <h2 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {project.title}
                            {project.hasAndroid && (
                                <FontAwesomeIcon icon={faAndroid} size="xs" />
                            )}
                            {project.hasIOS && (
                                <FontAwesomeIcon icon={faApple} size="xs" />
                            )}
                        </h2>
                        <p>{project.description}</p>
                    </div>
                ))}
            </div>

            <ProjectDetails
                open={!!selectedProject}
                onClose={() => setSelectedProject(null)}
                project={selectedProject}
                mode={mode}
            />
        </div>
    );
}

export default Project;